import HeroImage from "../../Components/HeroImage";
import servicesData from '../../JsonData/servicesData.json';
import Review from "../../Components/Review";
import { motion } from 'framer-motion';
const ServicesPage = () => {
 const slideInFromBottom = {
  initial: { opacity: 0, y: 50 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, amount: 0.2 },
  transition: { duration: 0.8, ease: "easeOut" },
};
  const services = servicesData;

  return (
    <>
     
      <HeroImage
        title="Services"
        subtitle="Expert Solutions for Every Step of Your Home Journey"
        imageSrc="/images/Services/servicesimage1.webp"
      />

      {/* Our Services Section */}


<section className="hidden md:flex flex-col justify-center items-center w-full lg:px-[106px] md:px-[64px] px-4 lg:mt-[200px] md:mt-[120px]">
  <motion.div className="flex flex-wrap lg:flex-nowrap justify-center gap-[76px]" {...slideInFromBottom}>
    {services.slice(0, 3).map((service, index) => (
      <motion.div
        key={index}
        className="relative flex flex-col items-center w-[408px] h-[272px]"
        whileHover={{ scale: 1.05 }}
      >
        <div className="flex items-center justify-center mb-3">
          <div className="relative w-[96px] h-[96px] rounded-[25px] bg-[#87A768] flex items-center justify-center">
            <img
              src={service.image}
              alt={service.title}
              className="absolute w-[44.81px] h-[44.81px] rounded-[25px] object-cover"
              style={{ 
                top: '25.46px',
                left: '25.46px'  // Adjusted from 142.47px to keep inside the parent box
              }}
            />
          </div>
        </div>
        <div className="flex flex-col items-center gap-[24px] w-[332px] h-[121px]">
          <h3 className="w-[332px] h-[25px] font-lora font-medium text-[24px] leading-[100%] tracking-[0px] text-[#204945] text-center">
            {service.title}
          </h3>
          <p className="w-[332px] h-[72px] font-outfit font-[350] text-[16px] leading-[24px] tracking-[0px] text-center text-[#777E90]">
            {service.description}
          </p>
        </div>

        {/* Vertical Dotted Line (Only between cards) */}
        {index < 2 && (
          <div className="hidden lg:block absolute top-4 right-[-12px] h-3/4 border-r-4 border-dotted border-[#9757D766]"></div>
        )}
      </motion.div>
    ))}
  </motion.div>
  
  {/* ...rest of the code... */}
 
{/* desktop view */}

{/* SECOND ROW — 2 Cards */}
<motion.div className="flex flex-wrap lg:flex-nowrap justify-center gap-[76px] w-[816px] h-[297px]" {...slideInFromBottom}>
  {services.slice(3).map((service, index) => (
    <motion.div
      key={index}
      className="relative flex flex-col items-center w-[408px] h-[297px]"
      whileHover={{ scale: 1.05 }}
    >
      <div className="w-[332px] h-[297px] flex flex-col items-center gap-[56px]">
        <div className="flex items-center justify-center">
          <div className="relative w-[96px] h-[96px] rounded-[25px] bg-[#87A768] flex items-center justify-center">
            <img
              src={service.image}
              alt={service.title}
              className="absolute w-[44.81px] h-[44.81px] rounded-[25px] object-cover"
              style={{ 
                top: '25.46px',
                left: '25.46px'  // Adjusted from 142.47px to keep inside parent box
              }}
            />
          </div>
        </div>
        
        <div className="flex flex-col items-center gap-[24px] w-[332px] h-[145px]">
          <h3 className="w-[332px] h-[25px] font-lora font-medium text-[24px] leading-[100%] tracking-[0px] text-center text-[#204945]">
            {service.title}
          </h3>
          <p className="w-[332px] h-[96px] font-outfit font-[350] text-[16px] leading-[24px] tracking-[0px] text-center text-[#777E90]">
            {service.description}
          </p>
        </div>
      </div>

      {index < 1 && (
        <div className="hidden lg:block absolute top-4 right-[-12px] h-3/4 border-r-4 border-dotted border-[#9757D766]"></div>
      )}
    </motion.div>
  ))}
</motion.div>






  
</section>
{/* MOBILE VIEW ONLY */}


<section className="block sm:hidden w-full h-[759px] flex flex-col items-center justify-start px-4 mt-[120px]">
  <div className="flex justify-center gap-x-[16px] mb-[47px]">
    {[0, 1].map((index) => (
      <motion.div
        key={index}
        initial={{ opacity: 0, x: index === 0 ? -100 : 100 }}
        whileInView={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.6, delay: index * 0.15 }}
        viewport={{ once: true, amount: 0.2 }}
        whileHover={{ scale: 1.05, y: -5 }}
        className="relative w-[180px] h-[240px] flex flex-col items-center gap-[16px]"
      >
        <div className="w-[164px] h-[240px] flex flex-col items-center gap-[32px]">
          <div className="flex items-center justify-center">
            <div className="relative w-[40px] h-[40px] rounded-[10px] bg-[#87A768] flex items-center justify-center">
              <img
                src={services[index].image}
                alt={services[index].title}
                className="absolute w-[21.43px] h-[21.43px] rounded-[10px] object-cover"
                style={{ 
                  top: '9.29px',
                  left: '9.29px'
                }}
              />
            </div>
          </div>
          <div className="text-center w-[164px] h-[161px] flex flex-col gap-[16px]">
            <h3 className="w-[164px] h-[25px] font-lora font-medium text-[14px] leading-[18px] tracking-[0px] text-[#204945] text-center">
              {services[index].title}
            </h3>
            <p className="w-[154px] h-[140px] font-outfit font-[350] text-[12px] leading-[20px] tracking-[0%] text-center text-[#777E90]">
              {services[index].description}
            </p>
          </div>
        </div>
        {index === 0 && (
          <div className="absolute top-20 right-[-6px] h-3/4 border-r-2 border-dotted   border-[#9757D766]" />
        )}
      </motion.div>
    ))}
  </div>
  <div className="flex justify-center gap-x-[16px] mb-[47px]">
    {[2, 3].map((index, i) => (
      <motion.div
        key={index}
        initial={{ opacity: 0, x: i === 0 ? -100 : 100 }}
        whileInView={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.6, delay: index * 0.15 }}
        viewport={{ once: true, amount: 0.2 }}
        whileHover={{ scale: 1.05, y: -5 }}
        className="relative w-[180px] h-[240px] flex flex-col items-center gap-[16px]"
      >
         <div className="w-[164px] h-[240px] flex flex-col items-center gap-[32px]">
         <div className="flex items-center justify-center">
      <div className="relative w-[40px] h-[40px] rounded-[10px] bg-[#87A768]">
        <img
          src={services[index].image}
          alt={services[index].title}
          className="absolute w-[19.09px] h-[15.73px] rounded-[6px] object-cover"
          style={{ 
            top: '12.31px',
            left: '10.29px'  // Changed from 72.2px to keep inside the parent box
          }}
        />
      </div>
    </div>
        <div className="text-center w-[164px] h-[161px] flex flex-col gap-[16px] ">
          <h3 className="w-[164px] h-[25px] font-lora font-medium text-[14px] leading-[18px] tracking-[0px] text-[#204945] text-center">{services[index].title}</h3>
          <p className="w-[164px] h-[100px] font-outfit font-[350] text-[12px] leading-[20px] tracking-[0%] text-center text-[#777E90]">
            {services[index].description}
          </p>
        </div>
        {i === 0 && (
          <div className="absolute top-20 right-[-6px] h-3/4 border-r-2 border-dotted border-[#9757D766]" />
        )}
        </div>
      </motion.div>
    ))}
  </div>
  <motion.div
    initial={{ opacity: 0, y: 100 }}
    whileInView={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.6, delay: 4 * 0.15 }}
    viewport={{ once: true, amount: 0.2 }}
    whileHover={{ scale: 1.05, y: -5 }}
    className="flex justify-center"
  >
    <div className="w-[175px] h-[180px] flex flex-col gap-[32px] items-center">
      <div className="flex items-center justify-center mb-3 px-2">
        <div className="relative w-[40px] h-[40px] rounded-[10px] bg-[#87A768] flex items-center justify-center">
          <img
            src={services[4].image}
            alt={services[4].title}
            className="w-[20px] h-[20px] object-cover"
          />
        </div>
      </div>
      <div className="text-center w-[175px] h-[101px] p-2">
        <h3 className="w-[175px] h-[25px] text-[14px] font-lora font-medium leading-[18px] tracking-[0px] text-[#204945] text-center">{services[4].title}</h3>
        <p className="w-[175px] h-[60px] font-outfit font-[350] text-[12px] leading-[20px] tracking-[0%] text-center text-[#777E90]">
          {services[4].description}
        </p>
      </div>
    </div>
  </motion.div>
</section>




    
    

     


 
     <div className=" lg:p-[200px] lg:mb-[200px] md:mb-[96px] md:mt-[200px] mb-[96px]">
      <Review /> 
      </div>
    </>
  );
};

export default ServicesPage;
